export const UrlParams: { [key: string]: string } = {
    Autoplay: "autoplay",
    OverrideStudioUserToken: "override_studio_user_token",
    OverrideEmbedToken: "override_embed_token",
    MenuEnabled: "menuenabled"
};
